/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m7.5802 11.36.002-.0006a2.2461 2.2461 0 0 0 1.4644-1.3225l2.8775-7.1622.001-.0025a.635.635 0 0 1 .7265-.3812l.0016.0004c1.0118.2289 1.6858 1.1893 1.5591 2.2213l-.6951 5.6623h8.2376c.483 0 .8394.4521.7278.9232l-1.9828 8.375-.0004.0017a.7484.7484 0 0 1-.7274.5751H8.8186a2.24 2.24 0 0 1-1.0424-.2575l-.0029-.0014-1.7887-.9439v-7.2308l1.5956-.4564Zm14.1746-2.485c.0292 0 .0583.0005.0872.0016 1.4037.053 2.4234 1.382 2.0967 2.7663l-.0004.0017-1.9828 8.375c-.2401 1.0143-1.1437 1.7304-2.1835 1.7304H8.8186a3.7324 3.7324 0 0 1-1.742-.4316l-1.1622-.6132c.0001-.0002 0 .0003 0 0a1.5018 1.5018 0 0 1-.2473.4689c-.274.3506-.7.5759-1.1787.5759H0V9h4.4884c.6198 0 1.1516.3779 1.3787.9164a1.4922 1.4922 0 0 1 .0987.345l1.2042-.344a.7496.7496 0 0 0 .4878-.4386l.001-.0024 2.8775-7.1622c.3906-.972 1.4267-1.5168 2.4463-1.286a.0278.0278 0 0 1 .0016.0003c1.7604.3992 2.9332 2.0704 2.7132 3.8665 0-.0003-.0001.0003 0 0l-.4886 3.98h6.546ZM4.4884 10.5H1.4961v9.75h2.9923V10.5Z"
    clipRule="evenodd"
  />,
  'Like'
);
